import { ChangeEvent, useEffect, useState } from "react";
import { useUserActions } from "../../Connect/_actions";
import SendingCode from "./SendingCode";
import WaitingForCode from "./WaitingForCode";
import "./Public.css";
import Loc from "../../Loc/Loc";

interface EnterMailProps {
    setEnterMail: React.Dispatch<React.SetStateAction<boolean>>;
    setStateSendingMail: React.Dispatch<React.SetStateAction<boolean>>;
    setWaitingForCode: React.Dispatch<React.SetStateAction<boolean>>;
    setAccess: React.Dispatch<React.SetStateAction<boolean>>;
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    setError: React.Dispatch<React.SetStateAction<string>>;
    error: string;
    hash: string;
    isSendingMail: boolean;
    isSendingSMS: boolean;
    waitingForCode: boolean;
    type: string;
    email: string;
}

export default function EnterMail(props: EnterMailProps) {
    const userActions = useUserActions();
    const [input, setInput] = useState("");
    const [autofill, setAutofill] = useState(false);
    const handleRetourOnClick = () => {
        props.setError("");
        props.setEnterMail(false);
    }
    const handleInputOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.setError("");
        setInput(event.target.value);
    }
    const handleSendOnClick = (event: React.FormEvent) => {
        event.preventDefault();
        props.setError("");
        props.setStateSendingMail(true);
        props.setWaitingForCode(false);
        // requête envoi mail
        userActions.sendCodeMail(props.hash, input)
        .then(() => {
            props.setStateSendingMail(false);
            props.setWaitingForCode(true);
            props.setEmail(input);
        })
        .catch(() => {
            console.log("Erreur probalement car pas de hash ou hash erroné");
            props.setError(Loc.trad().EnterMailError);
            props.setStateSendingMail(false);
        });
    }

    useEffect(() => {
        if (!autofill) {
            setInput(props.email);
            setAutofill(false);
        }
    }, [setAutofill, setInput, autofill, props.email])

    return (
        <form className="EnterMail" onSubmit={handleSendOnClick}>
            <h1 style={{color: 'white'}}>{Loc.trad().EnterMailAddress}</h1>
            <div style={{marginLeft: 'auto', marginRight: 'auto', width: '530px'}}>
                <div className="mx-sm-3 mb-2">
                    <input onChange={handleInputOnChange} type="email" className="form-control" placeholder="exemple@fivesgroup.com" value={input}/>
                </div>
            </div>
            {props.error !== "" && <div className="alert alert-danger mt-3" style={{marginLeft: 'auto', marginRight: 'auto', width: '400px'}}>{props.error}</div>}
            <button type="submit" className="btn btn-primary btn-lg">{Loc.trad().EnterMailSend}</button>
            <button onClick={handleRetourOnClick} className="btn btn-secondary btn-lg" style={{margin: '20px'}}>{Loc.trad().EnterMailBack}</button>
            <div>
                {props.isSendingMail ? <SendingCode type="mail"></SendingCode> : props.isSendingSMS && <SendingCode type="SMS"></SendingCode>}
                {props.waitingForCode && <WaitingForCode setAccess={props.setAccess} setWaitingForCode={props.setWaitingForCode} type={props.type} email={props.email} hash={props.hash}></WaitingForCode>}
            </div>
        </form>
    )
}